export const LocalStorageHelper = {
    ID_TOKEN: {
        set: (token: string) => {
            if (typeof window !== "undefined") {
                localStorage.setItem("idToken", token);
            }
        },
        get: () => {
            if (typeof window !== "undefined") {
                return localStorage.getItem("idToken");
            }
            return null;
        },
    },

    REFRESH_TOKEN: {
        set: (token: string) => {
            if (typeof window !== "undefined") {
                localStorage.setItem("refreshToken", token);
            }
        },
        get: () => {
            if (typeof window !== "undefined") {
                return localStorage.getItem("refreshToken");
            }
            return null;
        },
    },

    ACCESS_TOKEN: {
        set: (token: string) => {
            if (typeof window !== "undefined") {
                localStorage.setItem("accessToken", token);
            }
        },
        get: () => {
            if (typeof window !== "undefined") {
                return localStorage.getItem("accessToken");
            }
            return null;
        },
    },

    DEVICE_ID: {
        set: (token: string) => {
            if (typeof window !== "undefined") {
                localStorage.setItem("deviceId", token);
            }
        },
        get: () => {
            if (typeof window !== "undefined") {
                return localStorage.getItem("deviceId");
            }
            return null;
        },
    },

    clearAll: () => {
        if (typeof window !== "undefined") {
            // Dont clear device id, we want to keep it for tracking purposes
            localStorage.removeItem("idToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("globalTeam");
        }
    },
};
